export default "__VITE_ASSET__53b9eaf2__"